import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed0a6d84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "px-5 question-wrap d-flex flex-column"
}
const _hoisted_2 = {
  class: "mt-3",
  style: {"height":"90px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "toi float-start mt-2" }, "次の説明を読んで、各問に答えなさい。", -1))
const _hoisted_4 = {
  class: "row py-4 main-q",
  style: {"clear":"both","flex":"1"}
}
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = {
  key: 0,
  class: "border-div"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "right-box" }
const _hoisted_10 = {
  key: 0,
  style: {"display":"hidden"}
}
const _hoisted_11 = {
  key: 0,
  class: "tab-buttons"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  id: "footer",
  class: "d-flex mt-auto py-4"
}
const _hoisted_14 = { style: {"flex":"1"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timer = _resolveComponent("Timer")!
  const _component_TimerGage = _resolveComponent("TimerGage")!

  return (_ctx.questions.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Timer, {
            qIndex: _ctx.$route.params.id,
            onOverTimeAll: _ctx.overTimeAll,
            ref: "timer"
          }, null, 8, ["qIndex", "onOverTimeAll"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.questions.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " この問題は" + _toDisplayString(_ctx.questions.length) + "問組です ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              innerHTML: _ctx.questions[0].question1
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (q) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "",
                  key: q.id
                }, [
                  (_openBlock(), _createBlock(_KeepAlive, null, [
                    (_ctx.tabId == q.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (q != undefined)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent('Comp' + String(q.answerType)), {
                                qIndex: Number(_ctx.$route.params.id) - 1,
                                no: q.no,
                                questions: _ctx.data,
                                key: 'comp' + String(q.id)
                              }, null, 8, ["qIndex", "no", "questions"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 1024))
                ]))
              }), 128))
            ]),
            (_ctx.questions.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (q, i) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass({ active: _ctx.tabId === q.id }),
                      onClick: ($event: any) => (_ctx.tabId = q.id),
                      key: 'btn' + String(q.id)
                    }, _toDisplayString(i + 1), 11, _hoisted_12))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_TimerGage, {
              time: _ctx.time,
              onOverTime: _ctx.overTime,
              ref: "timerGage"
            }, null, 8, ["time", "onOverTime"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              style: {"margin-right":"1em"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
            }, "次へ"),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.end && _ctx.end(...args)))
            }, "終了")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}